<app-navbar-style-three></app-navbar-style-three>

<div class="bg-image">
    <div class="container" style="padding-top: 20px;">
      <div class="row" *ngIf="Multimedia_classroom_data?.length > 0">
        <ng-container *ngFor="let item of Multimedia_classroom_data">
          <!-- Text Column -->
          <div class="col-12 col-lg-6 mb-4 d-flex flex-column justify-content-center">
            <div
              style="
                background-size: 100px;
                padding: 20px;
                border: 1px solid #eeeeee;
                border-radius: 6px;
                height: 100%;
              "
            >
              <p class="fw-bold">{{ item.TitleEn }}</p>
              <p class="elip" style="text-align: justify;" [innerHTML]="item.DetailsEn"></p>
            </div>
          </div>

          <!-- Image Column -->
          <div class="col-12 col-lg-6 mb-4" *ngIf="item?.ShowAttachments?.length > 0">
            <div class="text-center h-100 d-flex align-items-center justify-content-center">
              <img
                [src]="item.ShowAttachments[0]?.FilePath"
                alt="image"
                class="img-fluid rounded shadow"
                style="max-height: 400px; object-fit: cover; width: 100%;"
              />
            </div>
          </div>
        </ng-container>
      </div>

      <ng-container *ngIf="Multimedia_classroom_data?.length === 0">
        <p class="text-center text-muted">No Data Found</p>
      </ng-container>
    </div>
  </div>


